import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chevron"]

  toggle() {
    const row = this.element.nextElementSibling
    if (!row) return

    const isHidden = row.classList.contains("hidden")

    if (isHidden) {
      row.classList.remove("hidden")
      this.chevronTarget.style.transform = "rotate(90deg)"
      this.chevronTarget.classList.add("text-core-purple-600")
      this.chevronTarget.classList.remove("text-support-dark-400")

      // Assign src on first expand so the frame fetches on click, not on viewport intersection
      const frame = row.querySelector("turbo-frame")
      if (frame && !frame.hasAttribute("src")) {
        const src = row.dataset.detailSrc
        if (src) frame.setAttribute("src", src)
      }
    } else {
      row.classList.add("hidden")
      this.chevronTarget.style.transform = ""
      this.chevronTarget.classList.remove("text-core-purple-600")
      this.chevronTarget.classList.add("text-support-dark-400")
    }
  }
}
